import Swal from "sweetalert2";
import { Form } from 'react-final-form';
import React, { useState } from 'react';
import { Button } from '@/shared/components/Button';
import AdminInterface from '@/utils/AdminInterface';
import withReactContent from "sweetalert2-react-content";
import { AsyncPaginate } from "react-select-async-paginate";
import { FormButtonToolbar, FormContainer, FormGroup, FormGroupField } from '@/shared/components/form/FormElements';

const UsersDropDown = (props) => {
    const [userValue, setUserValue] = useState({});

    const submitNewUserLicense = (licenseUser) => {
        licenseUser.license_id = props.selectedLicense.id;
        licenseUser.user_id = userValue.value;
        AdminInterface.instance.createLicenseUser(licenseUser).then(() => {
            withReactContent(Swal).fire({
                icon: "success",
                title: "Success",
                html: "Access to license is granted for the user!",
            });
            props.setListRequiresReload(true);
        }).catch(() => {
            withReactContent(Swal).fire({
                icon: "error",
                title: "Error",
                html: "Error in granting access to license for the user.",
            });
        });
    }

    const getUsers = async (page) => {
        let users = await AdminInterface.instance.getUsers(page, 10);
        let options = await users.data.map((userLicense) => {
            return {
                label: `${userLicense.given_name} ${userLicense.family_name} (...${userLicense.user_id.slice(-5)})`,
                value: userLicense.user_id
            }
        });

        return {
            results: options,
            has_more: options.length >= 10
        };
    };

    const loadOptions = async (searchQuery, loadedOptions, { page }) => {
        const response = await getUsers(page);

        return {
            options: response.results,
            hasMore: response.has_more,
            additional: {
                page: searchQuery ? 2 : page + 1,
            }
        };
    };

    const onChange = (value) => {
        setUserValue(value);
    };

    const customStyles = {
        option: (provided, state) => ({
            ...provided,
            backgroundColor: state.isFocused ? '#3699FF' : null,
            color: 'black',
        }),
    }

    return (
        <Form onSubmit={submitNewUserLicense}>
            {({ handleSubmit, form }) => (
                <FormContainer vertical onSubmit={handleSubmit}>
                    <FormGroup>
                        <FormGroupField>
                            <AsyncPaginate
                                name="user_id"
                                key="user_id"
                                isSearchable={false}
                                getOptionValue={(option) => option.value}
                                getOptionLabel={(option) => option.label}
                                placeholder="Select User"
                                loadOptions={loadOptions}
                                onChange={onChange}
                                styles={customStyles}
                                additional={{
                                    page: 1,
                                }} />
                        </FormGroupField>
                    </FormGroup>
                    <FormButtonToolbar>
                        <Button variant="primary" type="submit" disabled={!userValue.value}>Add</Button>
                    </FormButtonToolbar>
                </FormContainer>
            )}
        </Form>
    );
};

export default UsersDropDown;